import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

const HighlightContainer = styled.svg`
  cursor: pointer;
`;

const Highlight = ({width, height, color}) => {
  return (
    <HighlightContainer
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox="0 0 316 404"
      xmlSpace="preserve"
    >
      <circle cx="177.264" cy="102.584" r="40" fill={color} />
      <path
        d="M16.1299 77.3502C12.9727 66.2337 13.9006 54.7665 18.1319 44.7024C29.8952 48.719 43.0793 48.7929 55.5909 43.989C68.3435 39.0926 78.2243 29.9634 84.2479 18.8202C94.3829 23.4267 102.979 31.432 108.173 42.0099L16.1299 77.3502ZM111.664 51.3815C114.625 62.6736 113.407 74.2735 108.829 84.3531C97.0638 80.334 83.8764 80.2605 71.3622 85.0653C59.0862 89.7788 49.4707 98.4142 43.396 108.993C33.5 104.525 25.0618 96.8227 19.8082 86.6496L111.664 51.3815ZM74.5946 15.5775C69.6108 24.004 61.8557 30.8718 52.0065 34.6535C42.3551 38.3591 32.2155 38.5143 23.0213 35.7663C28.4929 27.822 36.3359 21.3891 46.0213 17.6703C55.4912 14.0343 65.389 13.5046 74.5946 15.5775ZM103.651 93.2033C98.2304 100.592 90.6973 106.563 81.5069 110.092C72.1028 113.703 62.2772 114.248 53.1262 112.226C58.1225 104.372 65.5894 97.9936 74.9466 94.4009C84.4997 90.7329 94.5317 90.5419 103.651 93.2033Z"
        fill="black"
      />
      <path
        d="M108.082 139.729C108.512 140.898 109.461 141.8 110.65 142.169L151.684 154.904C152.068 155.023 152.468 155.083 152.87 155.083H214.491C215.001 155.083 215.507 154.986 215.981 154.795L286.264 126.583C294.264 124.083 306.132 119.908 312.764 133.584C320.764 150.083 311.43 154.735 306.764 156.583L221.285 190.58C219.763 191.186 218.764 192.659 218.764 194.297V347.45C218.764 348.497 218.353 349.502 217.621 350.25L170.264 398.583C167.597 401.75 156.764 408.583 146.764 398.583C137.007 388.827 142.322 380.815 146.457 377.8C146.66 377.652 146.853 377.494 147.031 377.316L179.95 344.397C180.783 343.564 181.206 342.406 181.107 341.232L176.882 291.231C176.516 286.909 170.497 286.177 169.107 290.286L152.868 338.298C152.485 339.429 151.618 340.329 150.502 340.754L89.2636 364.083C76.2642 369.083 71.9634 370.083 64.7636 356.083C58.7123 344.316 70.2997 340.241 75.9372 336.787C76.1576 336.652 76.3849 336.536 76.6256 336.442L120.391 319.316C121.569 318.855 122.46 317.864 122.793 316.643L135.623 269.6C135.716 269.257 135.764 268.903 135.764 268.548V186.994C135.764 185.259 134.645 183.722 132.994 183.188L88.0627 168.665C86.9237 168.297 86.0095 167.438 85.571 166.324L69.5845 125.718C68.5802 123.167 70.3856 120.38 73.0996 119.993C80.2434 118.974 86.9711 116.664 93.0391 113.308C95.3089 112.052 98.2496 112.998 99.1451 115.433L108.082 139.729Z"
        fill="black"
      />
    </HighlightContainer>
  );
};

Highlight.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
};

export default Highlight;
